import React, { memo, useEffect, useRef, useState } from 'react';
import * as echarts from 'echarts';
import ReactECharts from 'echarts-for-react';

import * as _ from 'lodash';
import { log } from 'utils';
import { numberFormat } from 'utils';

function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  return ref.current;
}

function ChartDongTienRong(props) {
  const DEFAULT_OPTION = {
    grid: { top: 8, right: 60, bottom: 30, left: 25 },
    tooltip: {
      show: true,
      trigger: 'axis',
      // formatter: '{a} <br/>{b}: {c}',
      formatter: function (value, index) {
        // console.log(value[0]);
        return `${value[0].axisValue} : ${numberFormat(value[0].data)}`;
      },
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: [],
      // splitNumber: 5,
      // minInterval: 3600 * 1000,
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed',
          color: '#4E4D62',
          dashOffset: 10,
          opacity: 0.3,
        },
      },
      axisTick: {
        alignWithLabel: true,
        length: 3,
      },
      axisLabel: {
        color: '#83817C',
        fontSize: 8,
        formatter: function (value, index) {
          const arr = value.split(':');
          return arr[0] + ':' + arr[1];
        },
        // width: 100,
        // overflow: 'truncate',
        interval: 60,
        borderColor: '#ECECEC',
        showMinLabel: true,
        showMaxLabel: true,
      },
    },
    yAxis: {
      type: 'value',
      show: true,
      position: 'right',
      alignTicks: true,
      splitNumber: 4,
      splitLine: {
        // show: false,
        lineStyle: {
          type: 'dashed',
          color: '#4E4D62',
          dashOffset: 10,
          opacity: 0.3,
        },
      },
      axisLabel: {
        color: '#83817C',
        fontSize: 8,
        showMinLabel: false,
        showMaxLabel: false,
      },
    },
    series: [
      {
        type: 'line',
        smooth: true,
        symbol: 'none',
        sampling: 'lttb',
        itemStyle: {
          color: '#03CAA6',
        },
        lineStyle: {
          width: 1,
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: '#20CA78',
            },
            {
              offset: 1,
              color: 'rgba(61, 176, 85, 0)',
            },
          ]),
        },
        data: [],
      },
    ],
  };

  const [option, setOption] = useState(DEFAULT_OPTION);

  const { data } = props;

  const preIdata = usePrevious(data);

  useEffect(() => {
    if (data && !_.isEqual(data, preIdata)) {
      _mapDataToState(data);
    }
  }, [data]);

  function _mapDataToState(dt) {
    if (!dt.length) return;

    const newOption = _.cloneDeep(option);

    const yAxis = _.map(dt, 'TotalBuyActivelyValues');
    const xAxis = _.map(dt, 'Time');

    const _min = _.min(yAxis);
    const _max = _.max(yAxis);

    // // log(newOption);

    newOption.xAxis.data = xAxis;
    newOption.yAxis.min = _min;
    newOption.yAxis.max = _max;
    newOption.series[0].data = yAxis;
    // up
    newOption.series[0].itemStyle.color = '#03CAA6';
    newOption.series[0].areaStyle.color.colorStops[0].color = '#03CAA6';
    newOption.series[0].areaStyle.color.colorStops[1].color =
      'rgba(61, 176, 85, 0)';

    // console.log(xAxis);

    setOption(newOption);
  }

  return (
    <ReactECharts
      option={option}
      style={{
        height: '100%',
        width: `100%`,
      }}
    />
  );
}

export default memo(ChartDongTienRong);
